import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const pathDictionary: Record<string, string> = {
  // Products
  'meetingsense': 'Meeting Sense AI',
  'inventory-forecasting': 'Inventory Forecasting',
  'environmental-intelligence': 'Environmental Intelligence',
  'reaicoach': 'reAICoach',
  'sellagent': 'sellagent.ai',
  'sop-monitoring': 'SOP Monitoring',
  'hrms': 'HRMS',
  'intelligraph': 'IntelliGraph',
  'conversaigent': 'Conversaigent',
  'schoolflow360': 'SchoolFlow360',
  'eventflo360': 'EventFlo360',

  // Services
  'web-app-development': 'Web App Development',
  'website-development': 'Website Development',
  'marketplace-development': 'Marketplace Development',
  'pos-development': 'POS Development',
  'chatbots-conversational-ai': 'Chatbots & Conversational AI',
  'rag-systems': 'RAG Systems',
  'ai-frontdesk-assistant': 'AI Frontdesk Assistant',
  'ai-calling-agent': 'AI Calling Agent',
  'agentic-ai': 'Agentic AI',
  'computer-vision': 'Computer Vision',
  'crm-automation': 'CRM Automation',
  'lead-generation-automation': 'Lead Gen Automation',
  'workflow-automation': 'Workflow Automation',
  'seo-services': 'SEO Services',
  'social-media-marketing': 'Digital Marketing',
  'hire-a-developer': 'Hire a Developer',

  // Industries
  'critical-infrastructure': 'Critical Infrastructure',
  'geospatial-ai': 'Geospatial AI',

  // Primary Pages
  'privacy-policy': 'Privacy Policy',
  'terms-of-service': 'Terms of Service',
  'about': 'About Us',
  'contact': 'Contact',
  'insights': 'Insights',
  'services': 'Services',
  'products': 'Products',
  'solutions': 'Solutions',
  'industry': 'Industry',
  'social': 'Social',
  'app-development': 'App Development',
  'technology': 'Technology',
  'portfolio': 'Portfolio',
  'nodejs': 'Node.js',
  'aws': 'AWS',
  'pytorch': 'PyTorch'
};

const formatName = (str: string) => {
  if (pathDictionary[str]) return pathDictionary[str];
  return str.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

export const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  // Do not render breadcrumbs on home page
  if (pathnames.length === 0) return null;

  return (
    <nav aria-label="breadcrumb" className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 relative z-20">
      <ol className="flex flex-wrap items-center gap-2 text-xs sm:text-sm text-slate-500 dark:text-slate-400">
        <li>
          <Link to="/" className="hover:text-slate-900 dark:text-white transition-colors flex items-center gap-1.5">
            <Home className="w-3.5 h-3.5" />
            <span className="sr-only sm:not-sr-only">Home</span>
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;

          return (
            <li key={to} className="flex items-center gap-2">
              <ChevronRight className="w-3.5 h-3.5 text-slate-600" />
              {isLast ? (
                <span className="text-slate-900 dark:text-white font-medium" aria-current="page">
                  {formatName(value)}
                </span>
              ) : (
                <Link to={to} className="hover:text-slate-900 dark:text-white transition-colors">
                  {formatName(value)}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
